module.exports = __webpack_public_path__ + "img/placeholder.16ff3bf4.svg";